import { Component, Input } from '@angular/core';

@Component({
	selector: 'mb-risk-profile-indicator',
	templateUrl: './risk-profile-indicator.component.html',
	styleUrls: ['./risk-profile-indicator.component.scss']
})
export class RiskProfileIndicatorComponent {

	@Input() public riskGroupKey: string;
}
